import moment from "moment";
import axioPath from "api/axioPath";

const csvfunction = (getData) => {
  const finalCsvData = getData.flatMap(val => {
    const removeCommasLines = (text) => text?.trim()?.replaceAll(",", "-")?.replaceAll("\n", " ")?.replaceAll("\r", " ");
    const baseData = {
      BuyerInvoiceNumber: val?.invoiceDet?.buyerInvoiceId || 'NA',
      SellerInvoiceNumber: val?.invoiceDet?.sellerInvoiceId || 'NA',
      OrderId: val?.orderId,
      PTPlusOrderRefId: val?.ptplusRefNumber,
      PoNumber: val?.poNumber,
      Seller: removeCommasLines(val?.sellerInfo?.locationName),
      Buyer: removeCommasLines(val?.buyerInfo?.locationName),
      BuyerStreetAddress: removeCommasLines(val?.buyerInfo?.address),
      BuyerCity: removeCommasLines(val?.buyerInfo?.city),
      BuyerState: val?.buyerInfo?.state,
      BuyerZipCode: val?.buyerInfo?.zipCode,
      PickLocName: removeCommasLines(val?.pickupLocation?.locationName),
      PickStreetAddress: removeCommasLines(val?.pickupLocation?.address),
      PickCity: removeCommasLines(val?.pickupLocation?.city),
      PickState: val?.pickupLocation?.state,
      PickZipCode: val?.pickupLocation?.zipCode,
      SalesTaxCode: val?.salesTaxCode,
      SalesTaxDescription: removeCommasLines(val?.salesTaxDescription),
      Status: val.orderStatus === 'CANCELLED' ? 'CANCELED' : val.orderStatus,
      ClaimDetails: val?.claimDetails || 'NA',
      RequestedDate: val.requestedPickupDate ? moment(val.requestedPickupDate).format("MM-DD-YYYY") : 'NA',
      OrderCreatedDate: val.orderCreatedDate ? moment(val.orderCreatedDate).format("MM-DD-YYYY") : 'NA',
      ActualPickupDate: val.actualPickupDate ? moment(val.actualPickupDate).format("MM-DD-YYYY") : 'NA',
      SystemUpdatedDate: val.systemUpdatedDate ? moment(val.systemUpdatedDate).format("MM-DD-YYYY") : 'NA',
      PaymentIntiatedDate: val.paymentInitiateDate || 'NA',
      PaymentUpdatedDate: val.paymentUpdatedDate ? moment(val.paymentUpdatedDate).format("MM-DD-YYYY") : 'NA',
      BuyerAcNo: val?.buyerCard ? `****${val?.buyerCard}` : 'NA',
      SellerAcNo: val?.sellerCard ? `****${val?.sellerCard}` : 'NA',
      PaymentStatus: val?.payoutStatus || 'NA',
      PaymentType: val?.paymentType || 'NA',
      PayoutDate: val.payoutDate ? moment(val.payoutDate).format("MM-DD-YYYY") : 'NA',
      PayoutStatus: val?.payoutStatus || 'NA',
      OtherComments: removeCommasLines(val?.otherComment) || 'NA',
      BuyerComments: removeCommasLines(val?.buyerComment) || 'NA',
      SellerComments: removeCommasLines(val?.sellerComment) || 'NA',
    };

    if (!val.palletDetails || val.palletDetails.length === 0) {
      return [{
        ...baseData,
        ExtendedAmount: '$' + val?.extendedAmount?.toFixed(2),
        Tax: '$' + val?.tax?.toFixed(2),
        TaxDiff: '$' + val?.taxDiff?.toFixed(2),
        TaxRatePercent: val?.taxRate?.toFixed(2) + '%',
        SellerFeePT: '$' + val?.sellerFeeToPT?.toFixed(2),
        SellerFeePercent: val?.sellerFee + '%',
        SellerConnectFeePercent: val?.sellerConnectFeePercent + '%',
        SellerConnectFee: '$' + val?.sellerConnectFeeAmount?.toFixed(2),
        BuyerFeePT: '$' + val?.buyerFeeToPT?.toFixed(2),
        BuyerFeePercent: val?.buyerFee + '%',
        StripeFee: '$' + val?.stripeFeeAmount?.toFixed(2),
        CircularStripeFeeDiff: '$' + val?.circularStripeFeeDiff?.toFixed(2),
        StripeFeePercent: val?.stripeFeePercent + '%',
        StripeOtherFees: '$' + val?.stripeOtherFee?.toFixed(2),
        TotalFeesBuyer: '$' + val?.totalFeeBuyer?.toFixed(2),
        TotalAmountBuyer: '$' + val?.totalBuyerAmount?.toFixed(2),
        TotalAmountSeller: '$' + val?.totalSellerAmount?.toFixed(2),
        PalletType: 'NA',
        PalletQty: 'NA',
        VendorUnitPrice: 'NA',
        Subtotal: 'NA',
      }];
    }

    return val.palletDetails.map((pallets, index) => ({
      ...baseData,
      PalletType: pallets?.palletType,
      PalletQty: pallets?.qty,
      VendorUnitPrice: '$' + pallets?.vendorPrice,
      Subtotal: '$' + pallets?.vendorSubtotal,
      ExtendedAmount: index === 0 ? '$' + val?.extendedAmount?.toFixed(2) : '$0.00',
      Tax: index === 0 ? '$' + val?.tax?.toFixed(2) : '$0.00',
      TaxDiff: index === 0 ? '$' + val?.taxDiff?.toFixed(2) : '$0.00',
      TaxRatePercent: index === 0 ? val?.taxRate?.toFixed(2) + '%' : '0.00%',
      SellerFeePT: index === 0 ? '$' + val?.sellerFeeToPT?.toFixed(2) : '$0.00',
      SellerFeePercent: index === 0 ? val?.sellerFee + '%' : '0.00%',
      SellerConnectFeePercent: index === 0 ? val?.sellerConnectFeePercent + '%' : '0.00%',
      SellerConnectFee: index === 0 ? '$' + val?.sellerConnectFeeAmount?.toFixed(2) : '$0.00',
      BuyerFeePT: index === 0 ? '$' + val?.buyerFeeToPT?.toFixed(2) : '$0.00',
      BuyerFeePercent: index === 0 ? val?.buyerFee + '%' : '0.00%',
      StripeFee: index === 0 ? '$' + val?.stripeFeeAmount?.toFixed(2) : '$0.00',
      CircularStripeFeeDiff: index === 0 ? '$' + val?.circularStripeFeeDiff?.toFixed(2) : '$0.00',
      StripeFeePercent: index === 0 ? val?.stripeFeePercent + '%' : '0.00%',
      StripeOtherFees: index === 0 ? '$' + val?.stripeOtherFee?.toFixed(2) : '$0.00',
      TotalFeesBuyer: index === 0 ? '$' + val?.totalFeeBuyer?.toFixed(2) : '$0.00',
      TotalAmountBuyer: index === 0 ? '$' + val?.totalBuyerAmount?.toFixed(2) : '$0.00',
      TotalAmountSeller: index === 0 ? '$' + val?.totalSellerAmount?.toFixed(2) : '$0.00',
    }));
  });
  return finalCsvData;
};


const getCsvData = (filterDataTemp, page, searchKey) => {
  return new Promise((resolve, _reject) => {
    const token = localStorage.getItem("token")
    let url = `order/v2/admin/pickup/get_order_list`
    let data = {
      size: 100,
      number: page - 1 ?? 0,
      sort: "ASC",
      companyName: filterDataTemp?.companyName,
      state: filterDataTemp?.state,
      city: filterDataTemp?.city,
      orderStatus: filterDataTemp?.status.map(data => data.value),
      fromDate: moment(filterDataTemp?.fromDate).format('YYYY/MM/DD'),
      toDate: moment(filterDataTemp?.toDate).format('YYYY/MM/DD'),
      searchBy: searchKey
    }
    axioPath.post(url, data, {
      headers: {
        Authorization: token,
        UserType: 'external'
      },
    }).then((response) => {
      if (response.data.success) {
        if (response.data.data) {
          let userSubList = response.data.data
          resolve(userSubList)
        }
      } else {
        resolve({})
      }
    }).catch((_ex) => {
      resolve({})
    })
  })
}

let csvFinalData = [];
const handleCsvExportClick = async (filterData, currentPage, searchKey, setPickupOrderCsvCurrentPage, setPickupOrderCsvTotalPages, setIsDownloadingPickupOrderReportCSV, setCsvPickupOrderReportData) => {
  if (currentPage === 1) csvFinalData = []
  const userSubList = await getCsvData(filterData, currentPage, searchKey);
  let tempData = userSubList?.orderList || userSubList?.pickupOrderList || []
  let totalPages = userSubList?.totalPages ?? 1
  setPickupOrderCsvTotalPages(totalPages)
  csvFinalData.push(...tempData)

  if (totalPages > currentPage) {
    const nextPage = currentPage + 1;
    setPickupOrderCsvCurrentPage(nextPage)
    handleCsvExportClick(filterData, nextPage, searchKey, setPickupOrderCsvCurrentPage, setPickupOrderCsvTotalPages, setIsDownloadingPickupOrderReportCSV, setCsvPickupOrderReportData)
    return;
  }
  // return csvfunction(csvFinalData)
  const preparedCsvData = csvfunction(csvFinalData)
  setIsDownloadingPickupOrderReportCSV(false)
  setCsvPickupOrderReportData(preparedCsvData);

  const csvExportRef = document.querySelector("#csvPickupOrderExportRef")
  if (csvExportRef) {
    setTimeout(() => {
      csvExportRef.click();
    }, 500);
  }
}


export const ExportPickupOrderReport = (filterData, currentPage, searchKey, setPickupOrderCsvCurrentPage, setPickupOrderCsvTotalPages, setIsDownloadingPickupOrderReportCSV, setCsvPickupOrderReportData) => {
  setIsDownloadingPickupOrderReportCSV(true)
  handleCsvExportClick(filterData, currentPage, searchKey, setPickupOrderCsvCurrentPage, setPickupOrderCsvTotalPages, setIsDownloadingPickupOrderReportCSV, setCsvPickupOrderReportData)
}

export const csvPickupOrderReportHeaderArray = [
  { id: 'BuyerInvoiceNumber', displayName: 'Buyer Invoice Number' },
  { id: 'SellerInvoiceNumber', displayName: 'Seller Invoice Number' },
  { id: 'OrderId', displayName: 'Order Id' },
  { id: 'PTPlusOrderRefId', displayName: 'PT+ Order Reference Number' },
  { id: 'PoNumber', displayName: 'PO Number' },
  { id: 'Seller', displayName: 'Seller Name( PT+)' },
  { id: 'Buyer', displayName: 'Buyer Name (Vendor name)' },
  { id: 'BuyerStreetAddress', displayName: 'Buyer Street Address' },
  { id: 'BuyerCity', displayName: 'Buyer City' },
  { id: 'BuyerState', displayName: 'Buyer State' },
  { id: 'BuyerZipCode', displayName: 'Buyer Zip Code' },
  { id: 'PickLocName', displayName: 'Pickup Location Name' },
  { id: 'PickStreetAddress', displayName: 'Pickup Street Address' },
  { id: 'PickCity', displayName: 'Pickup City' },
  { id: 'PickState', displayName: 'Pickup State' },
  { id: 'PickZipCode', displayName: 'Pickup Zip Code' },
  { id: 'SalesTaxCode', displayName: 'Sales Tax Code' },
  { id: 'SalesTaxDescription', displayName: 'Sales Tax Description' },
  { id: 'Status', displayName: 'Status' },
  { id: 'ClaimDetails', displayName: 'Claim Details(Qty-Issue Type)' },
  { id: 'RequestedDate', displayName: 'Requested Date' },
  { id: 'OrderCreatedDate', displayName: 'Order Created Date' },
  { id: 'ActualPickupDate', displayName: 'Actual PU Date' },
  { id: 'SystemUpdatedDate', displayName: 'System Updated Date' },
  { id: 'PaymentIntiatedDate', displayName: 'Payment Intiated Date' },
  { id: 'PaymentUpdatedDate', displayName: 'Payment Updated Date' },
  { id: 'BuyerAcNo', displayName: 'Buyer A/c No.' },
  { id: 'SellerAcNo', displayName: 'Seller A/c No.' },
  { id: 'PaymentStatus', displayName: 'Payment Status' },
  { id: 'PaymentType', displayName: 'Payment Type' },
  { id: 'PayoutDate', displayName: 'Payout Date' },
  { id: 'PayoutStatus', displayName: 'Payout Status' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'PalletQty', displayName: 'Pallet Qty' },
  { id: 'VendorUnitPrice', displayName: 'Vendor Unit Price' },
  { id: 'Subtotal', displayName: 'Subtotal' },
  { id: 'ExtendedAmount', displayName: 'Extended Amount' },
  { id: 'Tax', displayName: 'Tax' },
  { id: 'TaxDiff', displayName: 'Tax Diff' },
  { id: 'TaxRatePercent', displayName: 'Tax Rate %' },
  { id: 'SellerFeePT', displayName: 'Seller Fee to PT' },
  { id: 'SellerFeePercent', displayName: 'Seller Fee %' },
  { id: 'SellerConnectFeePercent', displayName: 'Seller Connect Fee %' },
  { id: 'SellerConnectFee', displayName: 'Seller Connect Fee' },
  { id: 'BuyerFeePT', displayName: 'Buyer Fee to PT' },
  { id: 'BuyerFeePercent', displayName: 'Buyer Fee %' },
  { id: 'StripeFee', displayName: 'Stripe Fee' },
  { id: 'CircularStripeFeeDiff', displayName: 'Circular Stripe Fee Diff' },
  { id: 'StripeFeePercent', displayName: 'Stripe Fee %' },
  { id: 'StripeOtherFees', displayName: 'Stripe Other Fees' },
  { id: 'TotalFeesBuyer', displayName: 'Total Fees Buyer(Other Fee (Service & Stripe Fee))' },
  { id: 'TotalAmountBuyer', displayName: 'Total Amount Buyer' },
  { id: 'TotalAmountSeller', displayName: 'Total Amount Seller' },
  { id: 'OtherComments', displayName: 'Other Comments' },
  { id: 'BuyerComments', displayName: 'Buyer Comments' },
  { id: 'SellerComments', displayName: 'Seller Comments' },
]